import { styled, Avatar, Box, Stack, Grid, Typography } from "fashion/fabrics";
import { TouchAppIcon, ShareIcon, TravelExploreIcon } from "fashion/icons";

const ConceptAvatar = styled(Avatar)(() => ({
  width: 64,
  height: 64,
}));

const CodexConcept = () => (
  <Stack gap={3}>
    <Typography variant="h3" textAlign="center">
      Information{" "}
      <Box color="secondary.main" component="span" display="inline">
        Accessibility
      </Box>
    </Typography>
    <Typography color="text.secondary" textAlign="center">
      By creating simple, direct interfaces, people can have easier access to
      web based information.
    </Typography>
    <Grid sx={{ mt: 2 }} container rowSpacing={4} columnSpacing={2}>
      <Grid size={{ xs: 12, sm: 4 }}>
        <Stack alignItems="center" gap={1}>
          <ConceptAvatar>
            <TravelExploreIcon fontSize="large" />
          </ConceptAvatar>
          <Typography variant="h5" textAlign="center">
            Deep User Interfaces
          </Typography>
          <Typography color="text.secondary" textAlign="center">
            It enables quick creation of UI cards to navigate links on the web
            or more cards. It can be used to visualize information navigation.
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <Stack alignItems="center" gap={1}>
          <ConceptAvatar>
            <TouchAppIcon fontSize="large" />
          </ConceptAvatar>
          <Typography variant="h5" textAlign="center">
            Information Portals
          </Typography>
          <Typography color="text.secondary" textAlign="center">
            Users can create personalized cards tailored to their needs. It
            allows for the aggregation of relevant information into a
            user-friendly interface.
          </Typography>
        </Stack>
      </Grid>
      <Grid size={{ xs: 12, sm: 4 }}>
        <Stack alignItems="center" gap={1}>
          <ConceptAvatar>
            <ShareIcon fontSize="large" />
          </ConceptAvatar>
          <Typography variant="h5" textAlign="center">
            Information Sharing
          </Typography>
          <Typography color="text.secondary" variant="body1" textAlign="center">
            Users can easily share their created interfaces with others. It can
            be used to create simple training tools, or information kiosks.
          </Typography>
        </Stack>
      </Grid>
    </Grid>
  </Stack>
);

export default CodexConcept;
